import React, { Component } from 'react';
import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { lockEventRequest } from './actions';
import { getValueByKey } from 'containers/Popup/selectors';
import { setCommonPopup } from 'containers/Popup/actions';

class PopupLockEvent extends Component {
  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.closePopupLockEvent} className="confirm-popup">
        <div className="text-center message">このイベントを確定しますか？</div>
        <div>
          <button onClick={this.props.closePopupLockEvent}>戻る</button>
          <button onClick={() => {
            this.props.lockEventRequest(this.props.eventId);
            this.props.closePopupLockEvent();
          }}>確定する</button>
        </div>
      </Modal>
    );
  }
}

PopupLockEvent.propTypes = {
  eventId: PropTypes.string,
  show: PropTypes.bool,
  lockEventRequest: PropTypes.func,
  closePopupLockEvent: PropTypes.func
};

const mapStateToProps = state => {
  return {
    eventId: state.get('eventDetail').get('eventInfo').objectId,
    show: getValueByKey(state, 'lockEvent')
  };
};

const mapDispatchToProps = dispatch => ({
  lockEventRequest: (eventId) => dispatch(lockEventRequest(eventId)),
  closePopupLockEvent: () => dispatch(setCommonPopup('lockEvent', false))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withImmutablePropsToJS(PopupLockEvent));
